/**
 * 同一ブラウザの匿名 visitor を識別する UUID v4。
 * localStorage に保存して再訪時に同じ値を再利用する (会話履歴の継続のため)。
 *
 * delivery 単位ではなく**ブラウザ単位** (既存 widget と同パターン)。
 */
import { generateUuidV4 } from './uuid';

const STORAGE_KEY = 'suzanoh.visitor_id';

export function getOrCreateVisitorId(): string {
  try {
    const cached = window.localStorage.getItem(STORAGE_KEY);
    if (cached) return cached;
    const fresh = generateUuidV4();
    window.localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  } catch {
    // localStorage が disable (シークレットモード等) の時はメモリのみで生成
    return generateUuidV4();
  }
}
